import Link from 'next/link'
import { PREFETCH } from '@/lib/prefetch'
import type { Category, App, Criterion } from '@/payload-types'

export function generateIntro(apps: App[], category: Category) {
  const names = apps.map((app) => app.name)
  const appNames =
    names.length > 2
      ? `${names.slice(0, -1).join(', ')}, and ${names[names.length - 1]}`
      : names.join(' and ')
  return (
    <span>
      See how {appNames} compare{apps.length === 1 ? 's' : ''} on the most important{' '}
      <Link href={`/best/${category.slug}`} prefetch={PREFETCH} className="underlined primary">
        {category.name}
      </Link>{' '}
      criteria.
    </span>
  )
}

export function generateCriteriaList(criteria: Criterion[]) {
  const names = criteria.map((c) => c.name)
  if (names.length > 2) return `${names.slice(0, -1).join(', ')}, and ${names[names.length - 1]}`
  return names.join(' and ')
}
